import script from "./PrizeRow.vue?vue&type=script&setup=true&lang=js"
export * from "./PrizeRow.vue?vue&type=script&setup=true&lang=js"

import "./PrizeRow.vue?vue&type=style&index=0&id=73892a77&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73892a77"]])

export default __exports__